export default __webpack_public_path__ + "static/media/pen.7dad0dab.png";